import { z } from 'zod';

import type { PushSubscriptionBody } from '../types/domain.types';

const BASE64_BLOCK = 4;

export const applicationServerKeyOf = (base64Url: string): Uint8Array & BufferSource => {
  const padding = '='.repeat((BASE64_BLOCK - (base64Url.length % BASE64_BLOCK)) % BASE64_BLOCK);
  const base64 = `${base64Url}${padding}`.replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return Uint8Array.from(raw, (char) => char.charCodeAt(0));
};

const subscriptionJsonSchema = z.object({
  endpoint: z.string().min(1),
  expirationTime: z.number().nullable().optional(),
  keys: z.object({ p256dh: z.string().min(1), auth: z.string().min(1) }),
});

export interface DeviceInfo {
  readonly userAgent: string;
  readonly installed: boolean;
}

export const subscriptionBodyOf = (subscription: PushSubscription, device: DeviceInfo): PushSubscriptionBody => {
  const json = subscriptionJsonSchema.parse(subscription.toJSON());
  return {
    endpoint: json.endpoint,
    keys: json.keys,
    expirationTime: json.expirationTime ?? null,
    device,
  };
};
